// src/pages/client/Tutorials.jsx
import React from 'react';
import ClientNavbar from '../../components/client/ClientNavbar';
import Footer from '../../components/client/Footer';

const Tutorials = () => {
  const tutorialCategories = [
    {
      title: "Débutant",
      description: "Parfait pour commencer",
      color: "green",
      tutorials: [
        { title: "Premiers pas avec Jobrise", duration: "5 min", views: "2.3k" },
        { title: "Créer votre premier candidat", duration: "3 min", views: "1.8k" },
        { title: "Naviguer dans l'interface", duration: "7 min", views: "1.5k" }
      ]
    },
    {
      title: "Intermédiaire",
      description: "Approfondissez vos connaissances",
      color: "blue",
      tutorials: [
        { title: "Optimiser votre recherche candidats", duration: "12 min", views: "1.2k" },
        { title: "Gérer les processus de recrutement", duration: "15 min", views: "980" },
        { title: "Utiliser l'extension LinkedIn", duration: "8 min", views: "1.1k" }
      ]
    },
    {
      title: "Avancé",
      description: "Maîtrisez toutes les fonctionnalités",
      color: "purple",
      tutorials: [
        { title: "Automatiser vos workflows", duration: "20 min", views: "650" },
        { title: "Analytics et reporting avancé", duration: "18 min", views: "720" },
        { title: "Intégrations et API", duration: "25 min", views: "450" }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <ClientNavbar />
      
      {/* Hero Section */}
      <div className="pt-20 pb-16 bg-gradient-to-br from-indigo-600 via-blue-600 to-cyan-600">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-white mb-6">
            Tutoriels Vidéo
          </h1>
          <p className="text-xl text-indigo-100 mb-8 max-w-3xl mx-auto">
            Apprenez à maîtriser Jobrise étape par étape avec nos tutoriels vidéo détaillés
          </p>
          <div className="flex justify-center space-x-4">
            <button className="bg-white text-indigo-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition flex items-center">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
              </svg>
              Commencer les Tutoriels
            </button>
            <button className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-indigo-600 transition">
              Voir le Planning
            </button>
          </div>
        </div>
      </div>

      {/* Featured Tutorial */}
      <div className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-800 mb-4">
              Tutoriel en Vedette
            </h2>
            <p className="text-xl text-slate-600 max-w-2xl mx-auto">
              Notre tutoriel le plus populaire pour bien commencer
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl overflow-hidden mb-16">
            <div className="md:flex">
              <div className="md:w-1/2 bg-slate-900 flex items-center justify-center p-8">
                <div className="text-center">
                  <div className="w-20 h-20 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <p className="text-white text-lg">Cliquez pour voir le tutoriel</p>
                  <p className="text-indigo-300 text-sm">15 minutes · Niveau Débutant</p>
                </div>
              </div>
              <div className="md:w-1/2 p-8">
                <div className="flex items-center mb-4">
                  <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">POPULAIRE</span>
                  <span className="ml-2 text-sm text-slate-500">2.8k vues</span>
                </div>
                <h3 className="text-2xl font-bold mb-4">Guide Complet : De zéro à Expert</h3>
                <p className="text-slate-600 mb-6">
                  Découvrez toutes les fonctionnalités essentielles de Jobrise dans ce tutoriel complet. 
                  Nous couvrons l'import de candidats, la recherche avancée, et la gestion des processus.
                </p>
                <div className="space-y-3">
                  <div className="flex items-center text-sm text-slate-600">
                    <svg className="w-4 h-4 mr-2 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    Configuration de compte
                  </div>
                  <div className="flex items-center text-sm text-slate-600">
                    <svg className="w-4 h-4 mr-2 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    Import de candidats
                  </div>
                  <div className="flex items-center text-sm text-slate-600">
                    <svg className="w-4 h-4 mr-2 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    Recherche et filtres
                  </div>
                  <div className="flex items-center text-sm text-slate-600">
                    <svg className="w-4 h-4 mr-2 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    Gestion des processus
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tutorial Categories */}
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {tutorialCategories.map((category, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className={`p-6 bg-gradient-to-r ${
                  category.color === 'green' ? 'from-green-500 to-emerald-600' :
                  category.color === 'blue' ? 'from-blue-500 to-indigo-600' :
                  'from-purple-500 to-violet-600'
                }`}>
                  <h3 className="text-xl font-bold text-white mb-2">{category.title}</h3>
                  <p className="text-white text-opacity-90">{category.description}</p>
                </div>
                <div className="p-6">
                  <div className="space-y-4">
                    {category.tutorials.map((tutorial, tutIndex) => (
                      <div key={tutIndex} className="flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 transition cursor-pointer">
                        <div className="flex items-center">
                          <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 ${
                            category.color === 'green' ? 'bg-green-100' :
                            category.color === 'blue' ? 'bg-blue-100' :
                            'bg-purple-100'
                          }`}>
                            <svg className={`w-4 h-4 ${
                              category.color === 'green' ? 'text-green-600' :
                              category.color === 'blue' ? 'text-blue-600' :
                              'text-purple-600'
                            }`} fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                            </svg>
                          </div>
                          <div>
                            <h4 className="font-medium text-sm">{tutorial.title}</h4>
                            <div className="flex items-center text-xs text-slate-500 mt-1">
                              <span>{tutorial.duration}</span>
                              <span className="mx-2">•</span>
                              <span>{tutorial.views} vues</span>
                            </div>
                          </div>
                        </div>
                        <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Learning Path */}
          <div className="bg-white rounded-2xl shadow-xl p-8 mb-16">
            <h3 className="text-2xl font-bold text-center mb-8">Parcours d'Apprentissage Recommandé</h3>
            <div className="max-w-4xl mx-auto">
              <div className="relative">
                {/* Timeline line */}
                <div className="absolute left-8 top-8 bottom-8 w-0.5 bg-gray-200"></div>
                
                {/* Steps */}
                <div className="space-y-8">
                  {[
                    { 
                      step: 1, 
                      title: "Configuration & Premiers Pas", 
                      description: "Configurez votre compte et importez vos premiers candidats",
                      time: "15 min",
                      color: "blue"
                    },
                    { 
                      step: 2, 
                      title: "Maîtrise de la Recherche", 
                      description: "Apprenez à utiliser les filtres avancés et la recherche intelligente",
                      time: "20 min",
                      color: "green"
                    },
                    { 
                      step: 3, 
                      title: "Gestion des Processus", 
                      description: "Créez et gérez vos processus de recrutement",
                      time: "25 min",
                      color: "purple"
                    },
                    { 
                      step: 4, 
                      title: "Extension LinkedIn", 
                      description: "Installez et utilisez notre extension pour un sourcing optimal",
                      time: "10 min",
                      color: "indigo"
                    },
                    { 
                      step: 5, 
                      title: "Reporting & Analytics", 
                      description: "Analysez vos performances et optimisez vos résultats",
                      time: "30 min",
                      color: "orange"
                    }
                  ].map((item, index) => (
                    <div key={index} className="relative flex items-center">
                      <div className={`absolute left-0 w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-lg z-10 bg-${item.color}-500`}>
                        {item.step}
                      </div>
                      <div className="ml-24 bg-gray-50 p-6 rounded-lg flex-1">
                        <div className="flex justify-between items-start mb-2">
                          <h4 className="font-semibold text-lg">{item.title}</h4>
                          <span className="text-sm text-slate-500 bg-white px-2 py-1 rounded">{item.time}</span>
                        </div>
                        <p className="text-slate-600">{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Interactive Features */}
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h3 className="text-3xl font-bold mb-6">Fonctionnalités Interactives</h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <span className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center mr-3 mt-1">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </span>
                  <span>Sous-titres disponibles en français</span>
                </div>
                <div className="flex items-start">
                  <span className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center mr-3 mt-1">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </span>
                  <span>Exercices pratiques intégrés</span>
                </div>
                <div className="flex items-start">
                  <span className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center mr-3 mt-1">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </span>
                  <span>Certification de fin de parcours</span>
                </div>
                <div className="flex items-start">
                  <span className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center mr-3 mt-1">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </span>
                  <span>Support communautaire</span>
                </div>
              </div>
            </div>
            <div className="bg-gray-100 rounded-lg p-8">
              <p className="text-slate-500 text-center text-lg mb-4">
                [Screenshot de l'interface des tutoriels avec player vidéo]
              </p>
              <div className="h-64 bg-gradient-to-br from-indigo-100 to-blue-100 rounded-lg flex items-center justify-center">
                <span className="text-slate-600">Interface de Tutoriels Interactifs</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Tutorials;